import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import MapIcon from "../../../../images/mapTab.svg";
import DashboardIcon from "../../../../images/dashboardTab.svg";
import ExplorerIcon from "../../../../images/explorerTab.svg";
import DOMPurify from 'dompurify';

function ViewDeviceMapHeader(props) {
  const { id } = props;
  return (
      <div className="d-flex flex-row justify-content-between align-items-center view-device-dashboard-tab-container">
        <div className="view-device-dashboard-tab-text">Map</div>
        <div className="view-device-dashboard-tabs">
          <Link className="active" to={`/devices/${DOMPurify.sanitize(id)}/map`}>
            <img src={MapIcon} alt="MapIcon" />
          </Link>
          <Link to={`/devices/${DOMPurify.sanitize(id)}/dashboard`}>
            <img src={DashboardIcon} alt="MapIcon" />
          </Link>
          <Link to={`/devices/${DOMPurify.sanitize(id)}/explorer`}>
            <img src={ExplorerIcon} alt="MapIcon" />
          </Link>
        </div>
      </div>
  );
}
ViewDeviceMapHeader.propTypes = {
  id: PropTypes.string.isRequired,
};
export default ViewDeviceMapHeader;
